// possibly we can just handle all of this with axios-auth-refresh:
// https://stackoverflow.com/questions/51563821/axios-interceptors-retry-original-request-and-access-original-promise
// but, I'm not sure if it re-triggers the original request https://github.com/Flyrell/axios-auth-refresh/issues/194

// update: giving up when refresh attempt fails is a mess.
// can't seem to find where the error occurs or how to catch it.
// So, just counting failures in an outside variable that we always 
// increment, but set to 0 on successful refresh

// note -- this is super complicated (to me).
// The whole point is to handle case when access token is expired using interceptors:
// started w/ https://www.bezkoder.com/react-refresh-token/
// but, this doesn't allow for navigation back to login page.
// So, wrapped interceptor stuff in a component (https://dev.to/arianhamdi/react-hooks-in-axios-interceptors-3e1h)
// and now it seems to work.

// Still kind of confused... why do we just call "instance" inside api.tsx. It's inside of the new component
// (see app.tsx), so we are getting the version with interceptors added?? TODO - think about this.

// to get new access token, post the refresh token as "/api/token/refresh":
// https://simpleisbetterthancomplex.com/tutorial/2018/12/19/how-to-use-jwt-authentication-with-django-rest-framework.html

import * as React from 'react';
import axios from "axios";
import TokenService from "src/services/token";
import { useNavigate } from "react-router-dom";
import { config } from 'src/constants'

import {
    select_userMessage, setUserMessage
} from 'src/reducers/basicReducer';
import { useDispatch, useSelector } from 'react-redux'

const instance = axios.create({
    baseURL: config.url.API_URL + 'api/',
    headers: {
        "Content-Type": "application/json",
    },
});

let is_retry = false;

instance.interceptors.request.use(
    // https://stackoverflow.com/questions/70085215/how-to-fix-config-headers-authorization-object-is-possibly-undefined-when-usin
    (config) => {
        const token = TokenService.getLocalAccessToken();
        if (token) {
            if (config.headers === undefined) {
                config.headers = {};
            }
            config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
            // config.headers["x-access-token"] = token; // for Node.js Express back-end
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let failures = 0; // works w/ "failures" declared in the function below (at the top),
// but this gives a warning

const AxiosInterceptor = ({ children }: any) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {

        const interceptor = instance.interceptors.response.use(

            (res) => {
                console.log(res);
                return res;
            },
            async (err) => {
                const originalConfig = err.config;
                // I don't think we need to check the url, since we don't use this code
                // for logging in (AFAIK)
                // if (originalConfig.url !== "/auth/signin" && err.response) {
                if (err.response) {

                    if (failures > 5) {
                        TokenService.removeUser();
                        dispatch(setUserMessage("Session expired"));
                        navigate("/login")
                    }

                    if (err.response.status === 401 && !is_retry) {
                        try {
                            failures = failures + 1;

                            // important note -- if we don't return the original request, the token
                            // is refreshed, but our original request doesn't do anything!!
                            // https://stackoverflow.com/questions/70538409/axios-interceptor-wont-retry-original-call-on-react
                            return await instance.post("/token/refresh/", { // Django complains if no trailing slash!
                                refresh: TokenService.getLocalRefreshToken(), // JSON key should just be "refresh", not "refreshToken"!!
                            }).then(rs => {
                                failures = 0;
                                TokenService.updateLocalAccessToken(rs.data.access);
                                return instance(originalConfig);

                            });
                        } catch (error: any) {
                            return Promise.reject(error);
                        }
                    }
                }
                return Promise.reject(err);
            }
        );
        return () => instance.interceptors.response.eject(interceptor);
    }, [navigate])

    return children;
}


export default instance;
export { AxiosInterceptor }